import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllPayment(params: any): any {
    const baseUrl = '/api/admin/bankpayment';
    return api.get(`${baseUrl}`, params);
}

function ApiGetAllBank(params: any): any {
    const baseUrl = '/api/admin/bank';
    return api.get(`${baseUrl}`, params);
}

function ApiPostPayment(params: any): any {
    const baseUrl = '/api/admin/bankpayment';
    return api.create(`${baseUrl}`, params);
}

function ApiPutPayment(params: any, id: any): any {
    console.log(params);
    const baseUrl = '/api/admin/bankpayment/' + id;
    return api.update(`${baseUrl}`, params);
}
function ApiGetAllReportPayment(params: any): any {
    const baseUrl = '/api/admin/transaksireflexy/reportpayment';
    return api.get(`${baseUrl}`, params);
}

//print
function ApiPrintTransaksi(params: any): any {
    const baseUrl = '/api/admin/transaksireflexy/reporttransaksi/pdf';
    return api.getFile(`${baseUrl}`, params);
}
function ApiPrintPayment(params: any): any {
    const baseUrl = '/api/admin/transaksireflexy/reportpayment/pdf';
    return api.getFile(`${baseUrl}`, params);
}

function ApiGetAllReportTransaksi(params: any): any {
    const baseUrl = '/api/admin/transaksireflexy/reporttransaksi';
    return api.get(`${baseUrl}`, params);
}

function ApiGetPaymentCompany(params: any): any {
    const baseUrl = `/api/admin/get_company_product`;
    return api.get(`${baseUrl}`, params);
}

function ApiPostPaymentCompany(params: any): any {
    const baseUrl = `/api/admin/create_company_payment`;
    return api.create(`${baseUrl}`, params);
}

function ApiGetCompany(params: any): any {
    const baseUrl = `/api/admin/company`;
    return api.get(`${baseUrl}`, params);
}

function ApiPutCompany(params: any): any {
    const baseUrl = `/api/admin/company`;
    return api.update(`${baseUrl}`, params);
}

function ApiPostTagihanCompany(params: any): any {
    const baseUrl = `/api/admin/create_company_product`;
    return api.create(`${baseUrl}`, params);
}
export {
    ApiGetAllPayment,
    ApiGetAllBank,
    ApiPostPayment,
    ApiPutPayment,
    ApiGetPaymentCompany,
    ApiPostPaymentCompany,
    ApiGetCompany,
    ApiPostTagihanCompany,
    ApiPutCompany,
    ApiGetAllReportPayment,
    ApiGetAllReportTransaksi,
    ApiPrintTransaksi,
    ApiPrintPayment,
};
